import clsx from 'clsx';

type SkeletonProps = {
  /** Largura em CSS. Sem ela, a peça ocupa a linha toda. */
  width?: number | string;
  /** Altura em CSS. Sem ela, acompanha a altura do texto. */
  height?: number | string;
  className?: string;
};

/**
 * Reserva o lugar de um conteúdo que ainda está carregando. É decorativa: quem monta o
 * esqueleto anuncia o carregamento ao leitor de tela.
 */
const Skeleton = ({ width, height, className }: SkeletonProps) => (
  <span aria-hidden="true" className={clsx('skeleton placeholder', className)} style={{ width, height }} />
);

export default Skeleton;
